// extracted by mini-css-extract-plugin
export default {"guestAttempts_attempted":"guestAttempts-module__guestAttempts_attempted___OHoD6","guestAttempts_attempt":"guestAttempts-module__guestAttempts_attempt___Ch7Ry"};